import React,{useState, useEffect} from 'react';
import {
	Button,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Grid,Popover,Card,
	List,
	ListItem,
	ListItemText,
	Divider,
} from '@material-ui/core/';
import { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { kebabCase } from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ListAltIcon from '@material-ui/icons/ListAlt';
import { InputAdornment,IconButton, FormControl,InputLabel,OutlinedInput,Typography } from '@material-ui/core';
import { sendGetRequest, cancelGetRequest } from '../../utils/api';
import SubjectIcon from '@material-ui/icons/Subject';
import DynamicFeedIcon from '@material-ui/icons/DynamicFeed';

const useStyles = makeStyles((theme) => ({
	filterInput: {
		margin: '0.5rem',
		textAlign: 'left',
	},
	filterInputContainer: {
		paddingRight: '0.5rem',
	},
	accordion: {
		marginTop: '0.5rem',
	},
	form: {
		width: '200%',
	},
}));

const Filters = (props) => {
	const classes = useStyles();
	const { setSearchValues, searchValues, filterables, search, filterTable, filterQuery } = props;
	const [data, setData] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const handleChange = (e) => {
		setSearchValues({
			...searchValues,
			[e.target.name]: e.target.value,
		});
	};

	const [anchorEl, setAnchorEl] = useState(null);
	const popoverOpen = Boolean(anchorEl);
	const [id, setId] = useState('');

	const openValues = (event, p_key, p_static_list, p_list_path = null) =>{
		setId(p_key);
		setAnchorEl(event.currentTarget);

		filterData(p_key, p_static_list, p_list_path);
	}

	const closeValues = () =>{
		setAnchorEl(null);
		setId('');
	}

	const getFilterData = async () => {
		
		if(!filterTable) return;
		
		const path = `/${filterTable}`;
	
		//setFetchingData(true);
		const res = await sendGetRequest(path);
	
		// if (res.error) {
		// 	setSuccess(false);
		// 	setStatus(res.error.message);
		// 	setFetchingData(false);
		// 	return;
		// }
		console.log("Fetched filter data", res.data)
		setData(res.data)
		//setFetchingData(false);
		//setRows(res.data);
		//setSuccess(true);
		
	};
	
	const filterData = async (p_name, p_static_list, p_list_path = null) =>{
		const result = [];
		if(p_static_list){
			for (const item of p_static_list) {
				result.push({
					name: item
				});
			}
		}else{
			const map = new Map();

			if(data && !p_list_path){
				if(data.length > 0){
					for (const item of data) {
						if(!map.has(item[p_name])){
							map.set(item[p_name], true);    // set any value to Map
							result.push({
								name: item[p_name]
							});
						}
					}
				}
			}
			if(p_list_path){
				
				const path = `/${p_list_path}`;
				const res = await sendGetRequest(path);
				if(res.data){
					console.log(res.data);
					for (const item of res.data) {
						if(!map.has(item[p_name])){
							map.set(item[p_name], true);    // set any value to Map
							result.push({
								name: item[p_name]
							});
						}
					}
				}
			}
		}
		 
		setFilteredData(result)
	}

	useEffect( async ()=>{
		
		const getData = async () =>{
			await getFilterData();
		}

		getData();
	},[])

	//Wilbert Comicho
	//Added this function below for updating a single value.
	//Needed this function for Record Training

	const setFilterValueInput = ( p_value ) =>{
		setSearchValues({
		 	...searchValues,
		 	[id]: p_value,
		});
		closeValues();
	}

	const checkFilters = async (event) =>{
		event.preventDefault();

		let proceed = true;

		await filterables.forEach(function (item, key) {
			if(item.required === true){	
				if( searchValues[item.key].length === 0 && proceed === true){
					alert(kebabCase(item.key).toUpperCase() + ' is a required parameter. Please input/select a value for this filter. ');
					proceed = false;
				}
				
			}
		});
		
		if(proceed === true){
			search(event);
		}

	}

	useEffect(()=>{ 
		
		console.log("Values Updated:", searchValues);

	},[searchValues])
	
	return (
		<React.Fragment>
			
			<Accordion className={classes.accordion} defaultExpanded>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography variant="h6" align="left">FILTERS: </Typography></AccordionSummary>
			<AccordionDetails>
				<form
					className={classes.form}
					onSubmit={search}
					noValidate
					autoComplete="off"
				>
					<Grid
						container
						direction="row"
						justifyContent="center"
						alignItems="flex-start"
						spacing = {3}
					>
					
						{filterables.map((filterable) => (
							<Grid
								item
								lg={2}
								md={2}
								sm={3}
								xs={12}
								key={`${filterable.key}_search`}
							>
								<FormControl  variant="outlined" fullWidth className={classes.filterInput} >
									<InputLabel htmlFor={filterable.key}>{filterable.displayedHeader}</InputLabel>
									<OutlinedInput
										id = { filterable.key }
										type = { filterable.type ? filterable.type : 'text'}
										name = { filterable.key }
										value = { searchValues[filterable.key] }
										required = { filterable.required || false }
										onChange = { handleChange }
										
										endAdornment={
											
												filterable.withList === true && filterable.readOnly === true ? 
												<InputAdornment position="end">
													<IconButton
													edge="end"
													onClick={(e)=>{openValues(e, filterable.key, filterable.staticList, filterable.listPath)}}
													aria-describedby={filterable.key}
													>
													<ListAltIcon /> 
													</IconButton> 
												
												</InputAdornment> : 
													filterable.withList === true && filterable.readOnly === false ? 
													<InputAdornment position="end">
												
													<IconButton
													edge="end"
													onClick={(e)=>{openValues(e, filterable.key, filterable.staticList, filterable.listPath)}}
													aria-describedby={filterable.key}
													>
														
														<SubjectIcon /> 
													</IconButton> 
												
													</InputAdornment>
													 : <span></span>
											
											
										}
										labelWidth={200}
										error={false}
                                        fullWidth
									/>
								</FormControl>	
							</Grid>
						))}

					</Grid>
 
					<Grid
						container
						direction="row"
						justifyContent="center"
						alignItems="flex-start"
						spacing = {3}
						
					>
						<Grid item xs='auto'>	
							<Button
								type="submit"
								onClick={(e)=>{checkFilters(e);}}
								variant="contained"
								color="primary"
								size="large"
								startIcon={<DynamicFeedIcon />}
							>Filter
							</Button>	
						</Grid>
					</Grid>
				</form>
			</AccordionDetails>
			</Accordion>
			<Popover
				id={id}
				open={popoverOpen}
				anchorEl={anchorEl}
				onClose={closeValues}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
					}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
					}}
			>
				<Card>
					<List>
						{filteredData.map((item) => (		
						<Fragment
							key={`${kebabCase(item.name)}}`}
						>
							<ListItem key={`${kebabCase(item.name)}__${kebabCase(item.name)}`}>
								<ListItemText inset primary={item.name} onClick={ () => { setFilterValueInput(item.name) }} style={{"cursor":"pointer"}}/>
							</ListItem>
							<Divider />
						</Fragment>
										
								
							
						))}
					</List>
				</Card>
			</Popover>
		</React.Fragment>
		
	);
};

export default Filters;
